import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuthStore } from './stores/authStore';
import { ProjectProvider } from './contexts/ProjectContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';
import { MainLayout } from './components/Layout/MainLayout';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ForgotPassword } from './pages/ForgotPassword';
import { Dashboard } from './pages/Dashboard';
import { Preventivi } from './pages/Preventivi';
import { FinanziamentoPage as Finanziamento } from './pages/Finanziamento';
import { Notaio } from './pages/Notaio';
import { Gantt } from './pages/Gantt';
import { FlussiCassa } from './pages/FlussiCassa';
import { Scadenze } from './pages/Scadenze';
import { Resoconto } from './pages/Resoconto';
import { Task } from './pages/Task';
import { Rilievi } from './pages/Rilievi';
import { Documenti } from './pages/Documenti';
import { Detrazioni } from './pages/Detrazioni';
import { Projects } from './pages/Projects';
import { SchedaImmobile } from './pages/SchedaImmobile';

const queryClient = new QueryClient();

function App() {
  const isInitializing = useAuthStore((s) => s.isInitializing);
  const checkAuth = useAuthStore((s) => s.checkAuth);

  // Check auth once on mount
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        {/* Sotto le anteprime di branch l'app vive in /b/<slug>/: senza
            basename il router cercherebbe le rotte nella root del dominio. */}
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <ProjectProvider>
            {isInitializing ? (
              <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
                  <p className="mt-4 text-gray-600">Caricamento...</p>
                </div>
              </div>
            ) : (
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/preventivi"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Preventivi />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/finanziamento"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Finanziamento />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/notaio"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Notaio />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/immobile"
          element={
            <ProtectedRoute>
              <MainLayout>
                <SchedaImmobile />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/gantt"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Gantt />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/flussi-cassa"
          element={
            <ProtectedRoute>
              <MainLayout>
                <FlussiCassa />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/scadenze"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Scadenze />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/task"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Task />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/rilievi"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Rilievi />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resoconto"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Resoconto />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/documenti"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Documenti />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/detrazioni"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Detrazioni />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/progetti"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Projects />
              </MainLayout>
            </ProtectedRoute>
          }
        />


              {/* Catch all */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            )}
          </ProjectProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
